import axios from "axios";
let jsonpAdapter = require('axios-jsonp');

export function compareValues(key, order='asc') {
  return function(a, b) {
    if(!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }

    const varA = (typeof a[key] === 'string') ?
      a[key].toUpperCase() : a[key];
    const varB = (typeof b[key] === 'string') ?
      b[key].toUpperCase() : b[key];

    let comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return (
      (order == 'desc') ? (comparison * -1) : comparison
    );
  };
}

export function decodeHTML(html) {
	var txt = document.createElement('textarea');
	txt.innerHTML = html;
	return txt.value;
}

export function getConfig(config) {
  // console.log('ajax_params', ajax_params)
  // console.log('window.ajax_params', window.ajax_params)
  let c = ""
  let ap = {}

  if(typeof window.ajax_params !== 'undefined'){
    ap = window.ajax_params
  }
  if(JSON.stringify(ap) === '{}' ){
    if(typeof ajax_params === 'undefined'){
      ap = {
        events : "https://dev-register.thecove.org/events/query",
        types : "https://dev-register.thecove.org/lookup/types",
        limit : "12",
        errorMsg : "No Events are available that match your criteria. Please refine your search."
      }
    }else{
      ap = Object.assign({},ajax_params)
    }
  }
  

  switch (config) {
    case "events":
        c = ap.events;
      break;
    // case "detail":
    //     c = ap.detail;
      break;
    case "types":
      c = ap.types;
      break;
    case "limit":
      c = ap.limit;
      break;
    case "errorMsg":
      c = ap.errorMsg;
      break;
  }
  return c;
}
